import React from 'react';
import { cn } from './Card';
interface ProgressBarProps {
  value: number;
  max?: number;
  className?: string;
  colorClass?: string;
  heightClass?: string;
}
export function ProgressBar({
  value,
  max = 100,
  className,
  colorClass = 'bg-slate-900',
  heightClass = 'h-2'
}: ProgressBarProps) {
  const safeValue = Math.min(Math.max(value, 0), max);
  const percent = safeValue / max * 100;
  return <div className={cn('w-full overflow-hidden rounded-full bg-slate-100', heightClass, className)} data-id="element-301">
      <div className={cn('h-full transition-all duration-500 ease-in-out', colorClass)} style={{
      width: `${percent}%`
    }} data-id="element-302" />
    </div>;
}